export default "__VITE_ASSET__RPt8LimT__"